import { cn } from '~/lib/utils';

interface LogoProps {
  className?: string;
}

export const Search = ({ className }: LogoProps) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(!!className && className)}
    >
      <path
        d="M3.42871 21L9.42871 15M21.4287 10C21.4287 13.866 18.2947 17 14.4287 17C10.5627 17 7.42871 13.866 7.42871 10C7.42871 6.13401 10.5627 3 14.4287 3C18.2947 3 21.4287 6.13401 21.4287 10Z"
        stroke="#646464"
        strokeLinecap="round"
      />
    </svg>
  );
};
